module.exports = __webpack_public_path__ + "img/AI.7ef64106.png";